<template>
  <BaseTable
    :column-defs="columnDefs"
    :row-data="rowData"
    :default-col-def="defaultColDef"
    :row-height="56"
    :tooltip-show-delay="1000"
    :tooltip-hide-delay="60000"
    :no-rows-overlay-component="AgGridNoRowsOverlay"
    :no-rows-overlay-component-params="{
      message: noRowsMessage
    }"
    @grid-ready="$emit('on:grid-ready', $event)"
  />
</template>
<script setup>
import { dateComparator } from '@/composeables/ag_grid/comparators.js';
import { getProfileTooltipContent, getFollowersTooltipContent } from '@/api/apefluencer.js';
import AgGridTooltip from '@/components/ag_grid/AgGridTooltip.vue';
import AgGridNoRowsOverlay from '@/components/ag_grid/AgGridNoRowsOverlay.vue';

import FollowedProfileCell from './cells/FollowedProfileCell.vue';
import LatestFollowersCell from './cells/LatestFollowersCell.vue';
import FirstFollowedCell from './cells/FirstFollowedCell.vue';

const props = defineProps({
  rowData: Array,
  noRowsMessage: String
});

//TABLE CONFIG
const defaultColDef = {
  flex: 1,
  sortable: true,
  resizable: true,
  filter: false,
  tooltipComponent: AgGridTooltip
};
const columnDefs = [
  {
    headerName: 'Followed Profile',
    field: 'user_followed_metadata',
    sortable: false,
    cellStyle: { display: 'flex', 'align-items': 'center' },
    cellRenderer: FollowedProfileCell,
    tooltipComponentParams: { html: true },
    tooltipValueGetter: params => {
      return params?.data?.user_followed_metadata ? getProfileTooltipContent(params.data.user_followed_metadata) : '';
    }
  },
  {
    headerName: 'Account Created',
    field: 'user_followed_metadata.created_at',
    type: 'rightAligned',
    cellRenderer: 'BaseCellDateTime',
    comparator: dateComparator,
    cellRendererParams: { dateOnly: true, position: 'right' }
  },
  {
    headerName: '# of Followers',
    field: 'user_followed_metadata.followers_count',
    type: 'rightAligned',
    cellRenderer: 'BaseCellNumber',
    cellRendererParams: { decimals: 0 }
  },
  {
    headerName: 'Latest Key Followers',
    field: 'indicators',
    sortable: false,
    tooltipComponentParams: { html: true },
    tooltipValueGetter: params => {
      return params?.data?.indicators ? getFollowersTooltipContent(params.data.indicators) : '';
    },
    cellStyle: { display: 'flex', 'align-items': 'center' },
    cellRenderer: LatestFollowersCell
  },
  {
    headerName: 'First Followed',
    field: 'first_followed',
    sortable: false,
    headerClass: 'ag-right-aligned-header',
    cellStyle: { display: 'flex', 'align-items': 'center' },
    cellRendererParams: { position: 'right' },
    cellRenderer: FirstFollowedCell,
    tooltipComponentParams: { html: true },
    tooltipValueGetter: params => {
      return params?.data?.first_followed?.indicator_metadata
        ? getProfileTooltipContent(params.data.first_followed.indicator_metadata)
        : '';
    }
  }
];
</script>
